import React from 'react';
import {
  Box,
  Card,
  CardContent,
  Stack,
  Typography,
  Divider,
  Button
} from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import FacebookRoundedIcon from '@mui/icons-material/FacebookRounded';
import YouTubeIcon from '@mui/icons-material/YouTube';
import InstagramIcon from '@mui/icons-material/Instagram';
import { useParameterizedQuery } from 'react-fetching-library';
import { clientAgreementAction } from '../../services/request';
import toast from 'react-hot-toast';

export default function AgreementSent({ identifier, data, model, password, annexNr }) {
  const { loading, query } = useParameterizedQuery(clientAgreementAction);

  const handleLinkClick = link => {
    window.open(link, '_blank');
  };

  const isOrder = model === 'Order';
  const isEmployeeApplication = model === 'EmployeeApplication';
  const isObozy = data?.module === 'obozy';
  const isWyjazdyRodzinne = data?.module === 'wyjazdy_rodzinne';
  const isAnnex = identifier === 'aneks_zawarty';

  const paymentUrl = isAnnex
    ? data.left_to_pay_payment_url
    : data.full_payment_url;

  const paymentLabel = isAnnex
    ? 'ZAPŁAĆ POZOSTAŁĄ KWOTĘ'
    : 'ZAPŁAĆ CAŁOŚĆ NALEŻNOŚCI';

  const handleDownload = async () => {
    const {
      error: queryError,
      loading: queryLoading,
      payload: queryPayload
    } = await query(data.instance_id, 'download', password, annexNr);

    if (!queryError && !queryLoading) {
      let docName = '';
      if (annexNr > 0) {
        docName = `Aneks nr ${annexNr} do umowy ${data.agreement_number}.pdf`;
      } else {
        docName = `Umowa ${data.agreement_number}.pdf`;
      }
      const url = window.URL.createObjectURL(queryPayload);
      const a = document.createElement('a');

      document.body.appendChild(a);

      a.style = 'display: none';
      a.href = url;
      a.download = docName;

      a.click();

      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
    } else {
      toast.error('Nie udało się pobrać pliku');
    }
  };

  const handleSendEmail = async () => {
    const {
      error: queryError,
      loading: queryLoading
    } = await query(data.instance_id, 'email', password, annexNr);

    if (!queryError && !queryLoading) {
      toast.success('Wysłano mail z dokumentem');
    } else {
      toast.error('Nie udało się wysłać maila z dokumentem');
    }
  };


  const renderPaymentButtons = () => {
    if (data.below_30_days_to_start || data.quick_payment_promotion) {
      return (
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="center"
          mb={{ xs: 2, md: 4 }}
        >
          <Typography
            textAlign="center"
            sx={{
              fontSize: { xs: 12, md: 22 },
              flex: { xs: '0 0 auto', md: '1 1 15%' }
            }}
          >
            <b>{isObozy ? 'KROK 1' : '1.'}</b>&nbsp;
          </Typography>

          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            sx={{
              flex: { xs: '1 1 auto', md: '1 1 85%' }
            }}
          >
            <Button
              variant="contained"
              onClick={() => handleLinkClick(paymentUrl)}
            >
              <Typography
                sx={{ fontSize: { xs: 10, md: 22 } }}
                textAlign="center"
              >
                {paymentLabel}
              </Typography>
            </Button>
          </Stack>
        </Stack>
      );
    }

    return (
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="center"
        mb={{ xs: 2, md: 4 }}
      >
        <Typography
          textAlign="center"
          sx={{
            fontSize: { xs: 12, md: 22 },
            flex: { xs: '0 0 auto', md: '1 1 15%' }
          }}
        >
          <b>{isObozy ? 'KROK 1' : '1.'}</b>&nbsp;
        </Typography>

        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          sx={{
            flex: { xs: '1 1 auto', md: '1 1 85%' }
          }}
        >
          <Button
            variant="contained"
            onClick={() => handleLinkClick(data.advance_payment_url)}
          >
            <Typography sx={{ fontSize: { xs: 10, md: 22 } }}>
              ZAPŁAĆ ZALICZKĘ
            </Typography>
          </Button>

          <Typography
            textAlign="center"
            sx={{ fontSize: { xs: 12, md: 22 } }}
          >
            &nbsp; lub &nbsp;
          </Typography>

          <Button
            variant="contained"
            onClick={() => handleLinkClick(paymentUrl)}
          >
            <Typography
              sx={{ fontSize: { xs: 10, md: 22 } }}
              textAlign="center"
            >
              {paymentLabel}
            </Typography>
          </Button>
        </Stack>
      </Stack>
    );
  };

  const renderCamps = () => (
    <Stack
      direction="column"
      justifyContent="center"
      sx={{
        width: { xs: '100%', md: 900 },
        px: { xs: 1, md: 0 }
      }}
    >
      <Box sx={{ height: { xs: 0, md: 40 } }} />

      <Typography
        textAlign="center"
        sx={{
          fontSize: { xs: 16, md: 26 },
          mb: { xs: 1, md: 2 }
        }}
      >
        Zostały jeszcze <b>2 kroki:</b>
      </Typography>

      {renderPaymentButtons()}

      <Stack
        direction="row"
        alignItems="center"
        sx={{
          width: '100%',
          mb: { xs: 1, md: 7 }
        }}
      >
        <Typography
          textAlign="center"
          sx={{
            fontSize: { xs: 12, md: 22 },
            flex: { xs: '0 0 auto', md: '1 1 15%' }
          }}
        >
          <b>{isObozy ? 'KROK 2' : '2.'}</b>&nbsp;
        </Typography>

        <Button
          sx={{
            justifyContent: { xs: 'left', md: 'center' },
            textTransform: 'none',
            width: '100%',
            flex: { xs: '1 1 auto', md: '1 1 85%' }
          }}
          variant="contained"
          onClick={() => handleLinkClick(data.qualification_card_url)}
        >
          <Typography
            textAlign="center"
            sx={{ fontSize: { xs: 12, md: 22 } }}
          >
            WYPEŁNIJ KARTĘ KWALIFIKACYJNĄ – kod w pierwszym sms-ie
          </Typography>
        </Button>
      </Stack>

      <Stack
        direction="column"
        alignItems="center"
        sx={{
          mb: { xs: 1, md: 0 }
        }}
      >
        <Box
          sx={{
            width: { xs: 3, md: 35 },
            flex: { xs: '0 0 3px', md: '1 1 15%' }
          }}
        />

        { data.module == 'obozy' &&
        <Stack direction="row" mb={4}>
          <Button
            sx={{ mr: 2 }}
            variant="contained"
            size="large"
            onClick={handleDownload}
            disabled={loading}
          >
            <Typography
              sx={{ fontSize: { xs: 12, md: 22 } }}
            >
              <Box
                component="span"
              >
                POBIERZ
              </Box>
            </Typography>
          </Button>

          <Button
            variant="contained"
            size="large"
            onClick={handleSendEmail}
            disabled={loading}
          >
            <Typography
              sx={{ fontSize: { xs: 12, md: 22 } }}
            >
              <Box
                component="span"
              >
                WYŚLIJ NA SWÓJ @
              </Box>
            </Typography>
          </Button>
        </Stack>}

        <Button
          sx={{
            mt: { xs: 2, md: 2 },
            mb: { xs: 0, md: 2 },
            flex: { xs: '1 1 auto', md: '1 1 85%' }
          }}
          variant="contained"
          onClick={() => handleLinkClick(
            'https://sun-sport.pl/lato/strefa-rodzica#ubezpieczenie'
          )
          }
        >
          <Typography
            textAlign="center"
            sx={{ fontSize: { xs: 12, md: 22 } }}
          >
            ROZWAŻ UBEZPIECZENIE REZYGNACJI
            <br className="desktopOnly" />
            <Box
              component="span"
              sx={{
                display: { xs: 'none', md: 'inline' }
              }}
            >
              SPRAWDŹ CO SIĘ DZIEJE, JAK ZREZYGNUJESZ
            </Box>
          </Typography>
        </Button>
      </Stack>

      <Box sx={{ height: { xs: 20, md: 20 } }} />
    </Stack>
  );

  const renderFamilyTrips = () => (
    <Stack
      direction="column"
      justifyContent="center"
      sx={{
        width: { xs: '100%', md: 900 },
        px: { xs: 1, md: 0 }
      }}
    >
      <Box sx={{ height: { xs: 0, md: 40 } }} />

      <Typography
        textAlign="center"
        sx={{
          fontSize: { xs: 16, md: 26 },
          mb: { xs: 1, md: 2 }
        }}
      >
        Możesz teraz:
      </Typography>

      <Divider flexItem />

      {data.quick_payment_promotion ? (
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="center"
          mb={{ xs: 2, md: 4 }}
          mt={1}
          spacing={{ xs: 1, md: 5 }}
        >
          <Button
            variant="contained"
            onClick={() => handleLinkClick(data.left_to_pay_payment_url)}
          >
            <Typography sx={{ fontSize: { xs: 10, md: 22 } }}>
              ZAPŁAĆ CAŁOŚĆ NALEŻNOŚCI
            </Typography>
          </Button>
        </Stack>
      ) : (
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="center"
          mb={{ xs: 2, md: 4 }}
          mt={1}
          spacing={{ xs: 0, md: 5 }}
        >
          <Button
            variant="contained"
            onClick={() => handleLinkClick(data.advance_payment_url)}
          >
            <Typography sx={{ fontSize: { xs: 10, md: 22 } }}>
              ZAPŁAĆ ZALICZKĘ
            </Typography>
          </Button>

          <Typography
            textAlign="center"
            sx={{ fontSize: { xs: 12, md: 22 } }}
          >
            &nbsp; lub &nbsp;
          </Typography>

          <Button
            variant="contained"
            onClick={() => handleLinkClick(data.full_payment_url)}
          >
            <Typography sx={{ fontSize: { xs: 10, md: 22 } }}>
              ZAPŁAĆ CAŁOŚĆ NALEŻNOŚCI
            </Typography>
          </Button>
        </Stack>
      )}

      <Box sx={{ height: 20 }} />
    </Stack>
  );

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: {
          xs: '95vh',
          md: 'auto'
        }
      }}
    >
      <Card
        sx={{
          boxShadow: {
            xs: 'none',
            md: undefined
          },
          width: {
            xs: '100%',
            md: 'auto'
          }
        }}
      >
        <CardContent
          sx={{
            px: {
              xs: 0,
              md: 2
            }
          }}
        >
          <Stack
            justifyContent="center"
            alignItems="center"
            spacing={0}
          >
            <CheckCircleOutlineIcon
              color="primary"
              sx={{
                fontSize: {
                  xs: 72,
                  md: 100
                },
                mb: {
                  xs: 0,
                  md: 3
                }
              }}
            />

            <Typography
              variant="h3"
              textAlign="center"
              whiteSpace="pre-line"
            >
              {isAnnex ? 'Aneks został zawarty' : 'Umowa została zawarta'}
            </Typography>

            <Typography
              variant="h3"
              textAlign="center"
              textTransform="none"
              fontWeight="normal"
            >
              {isEmployeeApplication
                ? 'Zaakceptowaną umowę oraz dostęp do Twojego indywidualnego konta w Panelu Kartoteka przesłaliśmy na Twój adres e-mail'
                : isAnnex
                  ? 'Zaakceptowany aneks przesłaliśmy na Twój adres e-mail'
                  : 'Zaakceptowaną umowę przesłaliśmy na Twój adres e-mail'}
            </Typography>

            {isEmployeeApplication && (
              <>
                <Box sx={{ height: { xs: 30, md: 110 } }} />

                <Typography
                  textAlign="center"
                  sx={{ fontSize: { xs: 22, md: 26 } }}
                >
                  <i>Ciesz się pasją, postaw na rozwój!</i>
                </Typography>

                <Typography
                  textAlign="center"
                  sx={{ fontSize: { xs: 22, md: 26 } }}
                >
                  Dołącz do nas
                </Typography>

                <Box
                  onClick={() => handleLinkClick(
                    'https://www.facebook.com/groups/160178924602264/'
                  )
                  }
                  component="img"
                  src="/static/grupa.png"
                  sx={{
                    cursor: 'pointer',
                    width: 100,
                    height: { xs: 'auto', md: '80%' },
                    mb: 3,
                    mt: 2
                  }}
                />
              </>
            )}

            <Box sx={{ height: { xs: 20, md: 20 } }} />

            {isOrder && isObozy && renderCamps()}

            {isOrder && isWyjazdyRodzinne && renderFamilyTrips()}

            {isOrder && (
              <Stack
                direction="column"
                justifyContent="center"
                alignItems="center"
                sx={{
                  width: '100%'
                }}
              >
                <Box sx={{ height: { xs: 20, md: 40 } }} />

                <Divider sx={{ width: '100%' }} />

                <Box height={10} />

                <Typography
                  textAlign="center"
                  sx={{
                    fontSize: {
                      xs: 22,
                      md: 24
                    }
                  }}
                >
                  <i>
                    W międzyczasie obserwuj nas i zawsze bądź na bieżąco
                  </i>
                </Typography>

                <Stack direction="row" gap={2}>
                  <a
                    style={{
                      height: '80px',
                      color: '#4267B2'
                    }}
                    href="https://www.facebook.com/kalisz.sun.sport"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <FacebookRoundedIcon
                      sx={{
                        fontSize: {
                          xs: 60,
                          md: 80
                        }
                      }}
                    />
                  </a>

                  <a
                    style={{ height: '80px' }}
                    href="https://www.instagram.com/sun_sport.pl/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <InstagramIcon
                      sx={{
                        fill: 'url(#rg)',
                        fontSize: {
                          xs: 60,
                          md: 80
                        }
                      }}
                    />
                  </a>

                  <a
                    style={{
                      height: '80px',
                      color: 'red'
                    }}
                    href="https://www.youtube.com/@sun_sport_obozy"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <YouTubeIcon
                      sx={{
                        fontSize: {
                          xs: 60,
                          md: 80
                        }
                      }}
                    />
                  </a>
                </Stack>
              </Stack>
            )}
          </Stack>
        </CardContent>
      </Card>
    </Box>
  );
}
